<div class="modal-wrapper" *ngIf="showFormContent" [class.loading]="isLoading">
    <h2 class="title">Compra de crédito de revisão</h2>
    <p class="subtitle">Quantidade fixa: <strong>1</strong> crédito.</p>

    <!-- Resumo do item único -->
    <div class="summary">
        <div class="summary-item">
            <div class="summary-details">
                <p>Compra de crédito de revisão</p>
            </div>
            <p *ngIf="priceLabel">{{ priceLabel }}</p>
        </div>
        <div class="summary-total" *ngIf="priceLabel">
            <span>Total</span>
            <strong>{{ priceLabel }}</strong>
        </div>
    </div>

    <!-- Método de pagamento -->
    <div class="section">
        <label class="label">Forma de pagamento</label>
        <mat-form-field appearance="outline" class="full">
            <mat-select [value]="selectedPaymentMethod" (selectionChange)="onPaymentMethodChange($event.value)">
                <mat-option *ngFor="let m of paymentMethods" [value]="m.idPaymentMethod">
                    {{ m.paymentMethodName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- Parcelas -->
    <div class="section">
        <label class="label">Parcelas</label>
        <mat-form-field appearance="outline" class="full">
            <mat-select [(value)]="selectedPaymentMethodInstallment">
                <mat-option *ngFor="let i of paymentMethodInstallments" [value]="i.idPaymentMethodInstallment">
                    {{ getInstallmentLabel(i) }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- Cartões salvos / novo cartão (apenas quando o método for cartão) -->
    <div class="section" *ngIf="isCreditCardFlow">
        <div class="row">
            <div class="col">
                <label class="label">Cartões salvos</label>
                <mat-form-field appearance="outline" class="full">
                    <mat-select [(value)]="selectedCreditCardId">
                        <mat-option *ngFor="let c of userCreditCards" [value]="c.idUserCreditCard">
                            {{ c.paymentProcessor | uppercase }} •••• {{ c.lastFourDigits || '----' }}
                        </mat-option>
                        <mat-option [value]="null">Usar novo cartão</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- Form de novo cartão -->
        <div class="grid" *ngIf="showNewCreditCardForm" [formGroup]="creditCardForm">
            <mat-form-field appearance="outline">
                <mat-label>Nome (cartão)</mat-label>
                <input matInput formControlName="holderName" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Número do cartão</mat-label>
                <input matInput formControlName="number" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Mês (MM)</mat-label>
                <input matInput formControlName="expiryMonth" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Ano (YYYY)</mat-label>
                <input matInput formControlName="expiryYear" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>CVV</mat-label>
                <input matInput formControlName="ccv" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>CPF/CNPJ</mat-label>
                <input matInput formControlName="cpfCnpj" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Celular</mat-label>
                <input matInput formControlName="mobilePhone" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>IP</mat-label>
                <input matInput formControlName="remoteIp" />
            </mat-form-field>

            <mat-checkbox formControlName="saveCreditCard" class="col2">
                Salvar cartão
            </mat-checkbox>
        </div>

        <!-- Endereço de cobrança (mínimo exigido pelo payload) -->
        <div class="grid" [formGroup]="billingAddressForm">
            <mat-form-field appearance="outline">
                <mat-label>CEP</mat-label>
                <input matInput formControlName="postalCode" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Número</mat-label>
                <input matInput formControlName="addressNumber" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="col2">
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="addressComplement" />
            </mat-form-field>
        </div>
    </div>

    <!-- Ações -->
    <div class="actions">
        <button mat-stroked-button (click)="cancel()" [disabled]="isSubmitting">Cancelar</button>
        <button mat-raised-button color="primary" (click)="submit()"
            [disabled]="isSubmitting || !selectedPaymentMethod || !selectedPaymentMethodInstallment">
            {{ isSubmitting ? 'Processando...' : 'Pagar' }}
        </button>
    </div>
</div>

<!-- Loading inline -->
<div class="loading" *ngIf="isLoading">
    <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
    <span>Carregando...</span>
</div>